import { render, staticRenderFns } from "./ScorecardModal.vue?vue&type=template&id=528fc929&scoped=true"
import script from "./ScorecardModal.vue?vue&type=script&lang=js"
export * from "./ScorecardModal.vue?vue&type=script&lang=js"
import style0 from "./ScorecardModal.vue?vue&type=style&index=0&id=528fc929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fc929",
  null
  
)

export default component.exports